import __ from "../../../../services/translator";

export default function ButtonDelete(props?: any)
{
    return (
        <span className="strong">
            <i className="fas fa-trash-alt"></i>&nbsp;{ props?.text? props.text : __('Delete', 'delete') }
        </span>
    )
}